define(["require", "exports", "./jquery-plugins/touch-slider", "./jquery-plugins/input-watermark", "./jquery-plugins/jquery-ui-stubs", "./jquery-plugins/jquery-cookie", "./jquery-plugins/carousel", "./jquery-plugins/actionBar", "./jquery-plugins/draggable", "./jquery-plugins/numberInput", "./url", "./querystring", "./context", "./promptNewsLetter", "./debounce", "./contactus", "./images", "./attributePanel", "./bubbleText", "./bottomLessScroll", "./defer", "./productImages", "./priceFormula", "./notifications", "./addressBar", "./assetPicker", "./mobileProductPictures", "./customization", "./sideMenu", "./scrollWatcher", "./analytics", "./facebookApi", "./track", "./dialogs/login", "./dialogs/signup", "./dialogs/share", "./dialogs/addToCartSuccess", "./startCheckout", "./dialogs/newsletterSubscribe", "./ajaxCart", "./renderCustomValance", "./addToCart", "./assetFilter", "./dialogs/emailMissing", "./history", "./customDesign", "./slideSelect", "./colorTable", "./radioList", "./addOnItem", "./canvas", "./svg", "./asyncChain", "./resize", "./design", "./glfx", "./progress", "./paintColors", "./numberRange", "./autoSimulator", "./designbook", "./dialogs/filterCategory", "./favorites", "./listMenu", "./userMenu", "./loadStyle", "./contiunation", "./pager", "./advancedCustomize", "./liveView", "./scriptLoader", "./curtainSizeSpec", "./debugMenu", "./util"], function (require, exports, touchSlider, inputWatermark, jqueryui, jqueryCookie, jqueryCarousel, actionBar, draggable, numberInput, url, querystring, context_1, promptNewsLetter_1, debounce_1, contactUs, images, panel, bubbleText, bottomLess, defer_1, productImages, formula, notifications, address, picker, mobilePictures, customize, sideMenu, scrollWatcher, analytics_1, facebook, trackers, login_1, signup_1, shareDialog, addToCartSuccess_1, startCheckout_1, newsletterSubscribe_1, ajaxCart_1, renderCustomValance_1, addToCart_1, assetFilter_1, emailMissing_1, history_1, customDesign_1, slideSelect_1, colorTable_1, radioList_1, addOnItems, canvas, svg, asyncChain_1, resizable, design, glfx, progress, paintColors, range, autoSimulator, designbook, filterCategory_1, favorites, listMenu_1, userMenu, loadStyle_1, contiunation_1, pager, advancedCustomize_1, liveView, scriptLoader_1, sizeSpec, debugMenu_1) {
    "use strict";
    exports.__esModule = true;
    var _index = {
        addSampleToCart: ajaxCart_1.addSampleToCart,
        touchSlider: touchSlider,
        inputWatermark: inputWatermark,
        jqueryui: jqueryui,
        jqueryCookie: jqueryCookie,
        jqueryCarousel: jqueryCarousel,
        actionBar: actionBar,
        url: url,
        querystring: querystring,
        context: context_1["default"],
        promptNewsLetter: promptNewsLetter_1["default"],
        debounce: debounce_1["default"],
        contactUs: contactUs,
        images: images,
        panel: panel,
        bubbleText: bubbleText,
        bottomLess: bottomLess,
        defer: defer_1["default"],
        productImages: productImages,
        formula: formula,
        notifications: notifications,
        address: address,
        picker: picker,
        mobilePictures: mobilePictures,
        customize: customize,
        sideMenu: sideMenu,
        scrollWatcher: scrollWatcher,
        track: analytics_1["default"],
        facebook: facebook,
        login: login_1["default"],
        signup: signup_1["default"],
        emailMissing: emailMissing_1["default"],
        addToCartSuccess: addToCartSuccess_1["default"],
        startCheckout: startCheckout_1["default"],
        subscribe: newsletterSubscribe_1["default"],
        AjaxCart: ajaxCart_1.AjaxCart,
        renderPictures: renderCustomValance_1.renderPictures,
        complete_custom_parameters: renderCustomValance_1.complete_custom_parameters,
        drawCurtainSet: renderCustomValance_1.drawCurtainSet,
        loadImagesThenRender: renderCustomValance_1.loadImagesThenRender,
        getFabricNameFromCodeName: renderCustomValance_1.getFabricNameFromCodeName,
        getStyleIndexFromStyleName: renderCustomValance_1.getStyleIndexFromStyleName,
        ProductTypes: renderCustomValance_1.ProductTypes,
        addToCart: addToCart_1["default"],
        initDesktopFlyoutCart: ajaxCart_1.initFlyoutCartForDesktop,
        setupFilter: assetFilter_1.setupFilter,
        history: history_1["default"],
        trackers: trackers,
        syncAddressBar: customDesign_1.syncAddressBar,
        initDesigner: customDesign_1.initializeCustomDesigner,
        syncMatchingFabricApp: customDesign_1.syncMatchingFabricApplication,
        removeMatchingFabric: customDesign_1.removeMatchingFabric,
        toggleMatchingFabricSection: customDesign_1.toggleMatchingFabricSection,
        handleProductTypeChange: customDesign_1.handleProductTypeChange,
        RadioSelect: slideSelect_1.RadioSelect,
        controlVisibility: slideSelect_1.controlVisibility,
        colors: colorTable_1["default"],
        styleToMatchingFabricParts: renderCustomValance_1.styleToMatchingFabricParts,
        radioList: radioList_1.radioList,
        radioButtons: radioList_1.radioButtons,
        radioCurrent: radioList_1.radioCurrent,
        addOnItems: addOnItems,
        gotoCart: ajaxCart_1.gotoCart,
        canvas: canvas,
        svg: svg,
        setPerspectiveTransform: renderCustomValance_1.setPerspectiveTransform,
        asyncChain: asyncChain_1["default"],
        renderCanvas: renderCustomValance_1.renderCanvas,
        renderOverlayCanvas: renderCustomValance_1.renderOverlayCanvas,
        resizable: resizable,
        draggable: draggable,
        design: design,
        glfx: glfx,
        progress: progress,
        numberInput: numberInput,
        paintColors: paintColors,
        range: range,
        autoSimulator: autoSimulator,
        startInstructionAnimation: renderCustomValance_1.startInstructionAnimation,
        stopInstructionAnimation: renderCustomValance_1.stopInstructionAnimation,
        shareDialog: shareDialog,
        designbook: designbook,
        filterCategory: filterCategory_1["default"],
        favorites: favorites,
        ensureListMenu: listMenu_1.ensureListMenu,
        userMenu: userMenu,
        loadStyles: loadStyle_1["default"],
        triggerContinuation: contiunation_1.triggerContinuation,
        pager: pager,
        handleSheerChange: customDesign_1.handleSheerChange,
        gotoFullCustomization: advancedCustomize_1.gotoFullCustomization,
        liveView: liveView,
        loadScript: scriptLoader_1.loadScript,
        sizeSpec: sizeSpec,
        handleSizeEdit: customDesign_1.handleSizeEdit,
        setupDebugMenu: debugMenu_1.setupDebugMenu
    };
    exports["default"] = _index;
    $(function () {
        facebook.showOnLoadDialog();
    });
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/index.js
// module id = 0
// module chunks = 0